import { COLORS, IconName } from "@asayinc/component-library";
import dayjs from "dayjs";
import {
  TabulationReport,
  TabulationSendingStatus,
  TabulationStatus,
} from "src/store/tabulation/types";

export function getTabulationInfo(tabulation: TabulationReport): {
  iconName: IconName;
  color: string;
  label: string;
} {
  const { created, failedAt, sendingStatus, sentAt, status } = tabulation;

  if (sendingStatus === TabulationSendingStatus.SUCCESS) {
    if (status === TabulationStatus.COMPLETE_NO_CURRENT_VOTES) {
      return {
        iconName: "Warning",
        color: COLORS.ERROR_DARK,
        label: `Did not process on ${dayjs(created).format(
          "MM/DD/YYYY"
        )} - No current votes`,
      };
    }

    return {
      iconName: "CheckCircle",
      color: COLORS.SATURATED_GREEN,
      label: sentAt
        ? `Delivered on ${dayjs(sentAt).format("MM/DD/YYYY")}`
        : `Delivered (No date)`,
    };
  }

  if (sendingStatus === TabulationSendingStatus.FAILED) {
    return {
      iconName: "Warning",
      color: COLORS.ERROR_DARK,
      label: `Failed on ${dayjs(failedAt).format("MM/DD/YYYY")}`,
    };
  }

  if (status === TabulationStatus.QUEUED) {
    return {
      iconName: "HourglassTop",
      color: COLORS.P_MED_EMPHASIS,
      label: "Scheduled for -",
    };
  }

  return {
    iconName: "Spinner",
    color: COLORS.P_MED_EMPHASIS,
    label: "Sending",
  };
}
